import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  agentsList: [],
  agentsItem: {},
  agentsLoading: false,
  retellAgentsList: [],
};

const agentsSlice = createSlice({
  name: 'agentsSlice',
  initialState,
  reducers: {
    agentsLoadingSlice: (state, { payload }) => {
      state.agentsLoading = payload;
    },
    agentsListSlice: (state, { payload }) => {
      state.agentsList = payload;
    },
    agentsItemSlice: (state, { payload }) => {
      state.agentsItem = payload;
    },
    retellAgentsListSlice: (state, { payload }) => {
      state.retellAgentsList = payload;
    },
  },
});

const { actions, reducer } = agentsSlice;

export const {
  agentsLoadingSlice,
  agentsListSlice,
  agentsItemSlice,
  retellAgentsListSlice,
} = actions;

export default reducer;
